export default __webpack_public_path__ + "static/media/training-dojo.f9233d06.png";